const API_BASE = process.env.VUE_APP_API_BASE;
const API_NOTICIAS = `${API_BASE}/ajax/noticias.php`;

export default {
  namespaced: true,

  state: {
    noticias: [],
    noticiaActual: null,
    loading: false,
    error: null,
  },

  getters: {
    getAllNoticias: (state) => state.noticias,
    getNoticiasById: (state) => (id) => {
      return state.noticias.find((noticias) => noticias.id_noticias === id)
    },
    getNoticiaActual: (state) => state.noticiaActual,
    isLoading: (state) => state.loading,
    getError: (state) => state.error,
  },

  mutations: {
    SET_NOTICIAS(state, noticias) {
      state.noticias = Array.isArray(noticias) ? noticias.filter(Boolean) : []
    },
    SET_NOTICIA_ACTUAL(state, noticia) {
      state.noticiaActual = noticia
    },
    ADD_NOTICIAS(state, noticia) {
      state.noticias.push(noticia)
    },
    UPDATE_NOTICIA(state, updatedNoticia) {
      const index = state.noticias.findIndex((n) => n.id_noticias === updatedNoticia.id_noticias )
        if (index !== -1) {
          state.noticias.splice(index, 1, updatedNoticia)
        }
      },
    DELETE_NOTICIA(state, noticiaId) {
      state.noticias = state.noticias.filter((n) => n.id_noticias !== noticiaId)
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },

  actions: {
    async fetchNoticias({ commit }) {
      commit("SET_LOADING", true)
      commit("SET_ERROR", null)
      try {
        const response = await fetch(`${API_NOTICIAS}?action=getAll`)
        const data = await response.json()

        if (data.success) {
          commit("SET_NOTICIAS", data.noticias || [])
          return { success: true, count: data.noticias?.length || 0}
        } else {
          commit("SET_ERROR", data.message || "Error al cargar Noticias")
          return { success: false, message: data.message }
        }
      } catch (error) {
        console.error("Error fetching Noticias:", error)
        commit("SET_ERROR", "Error de conexión al cargar noticias")
      } finally {
        commit("SET_LOADING", false)
      }
    },

    /** 🔹 Obtener últimas 6 noticias para la landing */
    async fetchLandingNoticias({ commit }) {
      commit("SET_LOADING", true)
      commit("SET_ERROR", null)
      try {
        const response = await fetch(`${API_NOTICIAS}?action=getLanding`)
        const data = await response.json()

        if (data.success) {
          commit("SET_NOTICIAS", data.noticias || [])
          return { success: true, count: data.noticias?.length || 0 }
        } else {
          commit("SET_ERROR", data.message || "Error al cargar noticias de la landing")
          return { success: false, message: data.message }
        }
      } catch (error) {
        console.error("Error fetching landing noticias:", error)
        commit("SET_ERROR", "Error de conexión al cargar noticias de la landing")
        return { success: false, message: "Error de conexión" }
      } finally {
        commit("SET_LOADING", false)
      }
    },

    async fetchNoticiaById({ commit }, id_noticia) {
      commit("SET_LOADING", true)
      commit("SET_ERROR", null)
      try {
        const response = await fetch(`${API_NOTICIAS}?action=get`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id_noticia }),
        })

        const data = await response.json()
        console.log("📰 Noticia individual:", data)

        if (data.success) {
          commit("SET_NOTICIA_ACTUAL", data.noticia)
          return { success: true, noticia: data.noticia }
        } else {
          commit("SET_ERROR", data.message || "Error al cargar noticia")
          return { success: false, message: data.message }
        }
      } catch (error) {
        console.error("Error al cargar noticia:", error)
        commit("SET_ERROR", "Error de conexión")
        return { success: false, message: "Error de conexión" }
      } finally {
        commit("SET_LOADING", false)
      }
    },

    async addNoticia({ commit }, noticiaData) {
      commit("SET_LOADING", true)
      commit("SET_ERROR", null)
      try {
        const response = await fetch(`${API_NOTICIAS}?action=add`, {
          method: "POST",
          body: noticiaData,
        })
        const data = await response.json()

        if (data.success) {
          // El alta devuelve los datos en el nivel principal y no incluye
          // `data.noticia`. Evitamos insertar undefined antes de recargar.
          if (data.noticia) {
            commit("ADD_NOTICIAS", data.noticia)
          }
          return { success: true }
        } else {
          commit("SET_ERROR", data.message || "Error al agregar noticia")
          return { success: false, message: data.message }
        }
      } catch (error) {
        console.error("Error adding noticia:", error)
        commit("SET_ERROR", "Error de conexión al agregar noticia")
        return { success: false, message: "Error de conexión" }
      } finally {
        commit("SET_LOADING", false)
      }
    },

    async updateNoticia({ commit }, noticiaData) {
      commit("SET_LOADING", true)
      commit("SET_ERROR", null)
      try {
        const response = await fetch(`${API_NOTICIAS}?action=update`, {
          method: "POST",
          body: noticiaData,
        })
        const data = await response.json()

        if (data.success) {
          commit("UPDATE_NOTICIA", data.noticia)
          return { success: true }
        } else {
          commit("SET_ERROR", data.message || "Error al actualizar cliente")
          return { success: false, message: data.message }
        }
      } catch (error) {
        console.error("Error updating client:", error)
        commit("SET_ERROR", "Error de conexión al actualizar cliente")
        return { success: false, message: "Error de conexión" }
      } finally {
        commit("SET_LOADING", false)
      }
    },

    // Cambiar vigencia
    async toggleVigente({ dispatch }, { id, vigente }) {
      try {
        const res = await fetch(`${API_NOTICIAS}?action=setVigente`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id, vigente }),
        })
        const data = await res.json()
        if (data.success) {
          await dispatch("fetchNoticias")
        }
        return data
      } catch (err) {
        console.error("Error toggleVigente:", err)
        return { success: false }
      }
    },

    async deleteNoticia({ commit }, noticiaId) {
      commit("SET_LOADING", true)
      commit("SET_ERROR", null)
      try {
        const response = await fetch(`${API_NOTICIAS}?action=delete`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id_noticia: noticiaId }),
        })
        const data = await response.json()

        if (data.success) {
          commit("DELETE_NOTICIA", noticiaId)
          return { success: true }
        } else {
          commit("SET_ERROR", data.message || "Error al eliminar noticia")
          return { success: false, message: data.message }
        }
      } catch (error) {
        console.error("Error deleting client:", error)
        commit("SET_ERROR", "Error de conexión al eliminar noticia")
        return { success: false, message: "Error de conexión" }
      } finally {
        commit("SET_LOADING", false)
      }
    },
  }
}
